import { FC } from 'react';
import { useTranslation, Trans } from 'next-i18next';
import {
  EXTERNAL_PATHS,
  SUPPORT_URLS,
} from 'src/common/constants';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import PitchPageFAQ from 'src/common/components/PitchPageFAQ';
import Typography from 'src/common/components/Typography';
import UniversalLink from 'src/common/components/UniversalLink';

const faqList0 = [0, 1, 2, 3];
const faqList1 = [0, 1, 2, 3, 4, 5, 6, 7];
const faqList2 = [0, 1, 2, 3, 4, 5];
const faqList3 = [0, 1, 2, 3];

const RenterFAQ: FC = () => {
  const [t] = useTranslation('safety-page');

  return (
    <PitchPageLayout backgroundColor="bluminescence100">
      <PitchPageFAQ
        additionalText={(
          <Trans
            t={t}
            i18nKey="faq--text"
            components={{
              helpCenter: (
                <UniversalLink
                  href={SUPPORT_URLS.HELP_CENTER}
                  openInNewTab
                />
              ),
              break: (
                <br />
              ),
            }}
          />
        )}
        faqs={[
          {
            question: t('renter-faq--question-0'),
            answer: (
              <>
                <Typography type="p" size="body-l">
                  {t('renter-faq--answer-0--p-0')}
                </Typography>
                <ul>
                  {faqList0.map((item) => (
                    <li key={item}>
                      <Typography type="p" size="body-l">
                        {t(`renter-faq--answer-0--list-0--listItem-${item}`)}
                      </Typography>
                    </li>
                  ))}
                </ul>
                <Typography type="p" size="body-l">
                  <Trans
                    t={t}
                    i18nKey="renter-faq--answer-0--p-1"
                    components={{
                      learnMore: (
                        <UniversalLink
                          href={SUPPORT_URLS.BOATING_SAFETY_BASICS}
                          openInNewTab
                        />
                      ),
                    }}
                  />
                </Typography>
              </>
            ),
          },
          {
            question: t('renter-faq--question-1'),
            answer: (
              <ul>
                {faqList1.map((item) => (
                  <li key={item}>
                    <Typography type="p" size="body-l">
                      <Trans
                        t={t}
                        i18nKey={`renter-faq--answer-1--list-0--listItem-${item}`}
                        components={{
                          weatherLink: (
                            <UniversalLink
                              href={`${EXTERNAL_PATHS.JOURNAL}how-to/gear-for-boating-in-foul-weather/`}
                              openInNewTab
                            />
                          ),
                          sunscreenLink: (
                            <UniversalLink
                              href={`${EXTERNAL_PATHS.JOURNAL}how-to-take-care-of-your-skin-while-boating/`}
                              openInNewTab
                            />
                          ),
                        }}
                      />
                    </Typography>
                  </li>
                ))}
              </ul>
            ),
          },
          {
            question: t('renter-faq--question-2'),
            answer: (
              <>
                <Typography type="p" size="body-l">
                  {t('renter-faq--answer-2--p-0')}
                </Typography>
                <ul>
                  {faqList2.map((item) => (
                    <li key={item}>
                      <Typography type="p" size="body-l">
                        <Trans
                          t={t}
                          i18nKey={`renter-faq--answer-2--list-0--listItem-${item}`}
                          components={{
                            lifeJacketLink: (
                              <UniversalLink
                                href={`${EXTERNAL_PATHS.JOURNAL}boating-safety/guide-to-life-jackets-for-kids/`}
                                openInNewTab
                              />
                            ),
                            radioLink: (
                              <UniversalLink
                                href={`${EXTERNAL_PATHS.JOURNAL}boating-safety/how-to-use-a-marine-radio/`}
                                openInNewTab
                              />
                            ),
                          }}
                        />
                      </Typography>
                    </li>
                  ))}
                </ul>
                <Typography type="p" size="body-l">
                  {t('renter-faq--answer-2--p-1')}
                </Typography>
              </>
            ),
          },
          {
            question: t('renter-faq--question-3'),
            answer: (
              <>
                <Typography type="p" size="body-l">
                  {t('renter-faq--answer-3--p-0')}
                </Typography>
                <ul>
                  {faqList3.map((item) => (
                    <li key={item}>
                      <Typography type="p" size="body-l">
                        {t(`renter-faq--answer-3--list-0--listItem-${item}`)}
                      </Typography>
                    </li>
                  ))}
                </ul>
                <Typography type="p" size="body-l">
                  <Trans
                    t={t}
                    i18nKey="renter-faq--answer-3--p-1"
                    components={{
                      learnMore: (
                        <UniversalLink
                          href={SUPPORT_URLS.HOW_TO_PREPARE_FOR_BAREBOAT}
                          openInNewTab
                        />
                      ),
                    }}
                  />
                </Typography>
              </>
            ),
          },
        ]}
        title={t('renter-faq--title')}
      />
    </PitchPageLayout>
  );
};

export default RenterFAQ;
